import { render } from "./ListOfSubCategories.vue?vue&type=template&id=c66e7e88&scoped=true&ts=true"
import script from "./ListOfSubCategories.vue?vue&type=script&lang=ts"
export * from "./ListOfSubCategories.vue?vue&type=script&lang=ts"

import "./ListOfSubCategories.vue?vue&type=style&index=0&id=c66e7e88&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c66e7e88"]])

export default __exports__